import React from 'react';
export default function EmptyAvatar() {
  return React.createElement("svg", {
    width: '34',
    height: '34',
    viewBox: '0 0 75 75',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg'
  }, React.createElement("g", {
    "clip-path": 'url(#clip0_1369_28173)'
  }, React.createElement("rect", {
    width: '75',
    height: '75',
    rx: '37.5',
    fill: 'url(#paint0_linear_1369_28173)'
  }), React.createElement("rect", {
    width: '75',
    height: '75',
    rx: '37.5',
    fill: 'url(#paint1_radial_1369_28173)',
    "fill-opacity": '0.7'
  }), React.createElement("rect", {
    width: '75',
    height: '75',
    rx: '37.5',
    fill: 'url(#paint2_radial_1369_28173)',
    "fill-opacity": '0.3'
  })), React.createElement("defs", null, React.createElement("linearGradient", {
    id: 'paint0_linear_1369_28173',
    x1: '9.43709',
    y1: '9.52135',
    x2: '64.7763',
    y2: '60.7731',
    gradientUnits: 'userSpaceOnUse'
  }, React.createElement("stop", {
    "stop-color": '#7701BB'
  }), React.createElement("stop", {
    offset: '0.0745527',
    "stop-color": '#7601BB'
  }), React.createElement("stop", {
    offset: '0.146751',
    "stop-color": '#7503BC'
  }), React.createElement("stop", {
    offset: '0.216879',
    "stop-color": '#7205BD'
  }), React.createElement("stop", {
    offset: '0.285219',
    "stop-color": '#6E09BF'
  }), React.createElement("stop", {
    offset: '0.352055',
    "stop-color": '#690DC1'
  }), React.createElement("stop", {
    offset: '0.41767',
    "stop-color": '#6312C4'
  }), React.createElement("stop", {
    offset: '0.482348',
    "stop-color": '#5C18C7'
  }), React.createElement("stop", {
    offset: '0.54637',
    "stop-color": '#541FCA'
  }), React.createElement("stop", {
    offset: '0.610022',
    "stop-color": '#4C27CE'
  }), React.createElement("stop", {
    offset: '0.673586',
    "stop-color": '#422FD2'
  }), React.createElement("stop", {
    offset: '0.737345',
    "stop-color": '#3738D7'
  }), React.createElement("stop", {
    offset: '0.801582',
    "stop-color": '#2C42DC'
  }), React.createElement("stop", {
    offset: '0.866582',
    "stop-color": '#204DE1'
  }), React.createElement("stop", {
    offset: '0.932627',
    "stop-color": '#1358E7'
  }), React.createElement("stop", {
    offset: '1',
    "stop-color": '#0564ED'
  })), React.createElement("radialGradient", {
    id: 'paint1_radial_1369_28173',
    cx: '0',
    cy: '0',
    r: '1',
    gradientUnits: 'userSpaceOnUse',
    gradientTransform: 'translate(10.9272 4.00899) rotate(74.8737) scale(34.2612 83.814)'
  }, React.createElement("stop", {
    "stop-color": '#F5EBFA'
  }), React.createElement("stop", {
    offset: '0.161458',
    "stop-color": '#EEDEF6',
    "stop-opacity": '0.864583'
  }), React.createElement("stop", {
    offset: '0.333333',
    "stop-color": '#E8D2F3',
    "stop-opacity": '0.735701'
  }), React.createElement("stop", {
    offset: '0.661458',
    "stop-color": '#D1A8E8',
    "stop-opacity": '0.290563'
  }), React.createElement("stop", {
    offset: '0.822917',
    "stop-color": '#C999E4',
    "stop-opacity": '0.137944'
  }), React.createElement("stop", {
    offset: '1',
    "stop-color": '#C28CE0',
    "stop-opacity": '0'
  })), React.createElement("radialGradient", {
    id: 'paint2_radial_1369_28173',
    cx: '0',
    cy: '0',
    r: '1',
    gradientUnits: 'userSpaceOnUse',
    gradientTransform: 'translate(61.0927 67.1506) rotate(-120.035) scale(20.8387 46.6438)'
  }, React.createElement("stop", {
    "stop-color": '#E8F2FF'
  }), React.createElement("stop", {
    offset: '0.0001',
    "stop-color": '#E8F2FF'
  }), React.createElement("stop", {
    offset: '1',
    "stop-color": '#99C3F9',
    "stop-opacity": '0'
  }))));
}